module.exports = __webpack_public_path__ + "static/media/G3.e9e872f3.png";